import { containerVanConstants } from '../../_constants';

export function containerVans(state = {}, action) {
    switch (action.type) {
        case containerVanConstants.CONTAINER_VAN_FETCHING:
            return {
                ...state,
                containerVanFetching: true
            };
        case containerVanConstants.CONTAINER_VAN_FETCHED:
            return {
                ...state,
                containerVanFetching: false
            };
        case containerVanConstants.CONTAINER_VAN_SUBMITTING:
            return {
                ...state,
                containerVanSubmitting: true
            };
        case containerVanConstants.CONTAINER_VAN_SUBMITTED:
            return {
                ...state,
                containerVanSubmitting: false
            };
        case containerVanConstants.GET_CONTAINERS:
            return {
                ...state,
                containers: action.containers
            };
        case containerVanConstants.GET_CONTAINER:
            return {
                ...state,
                container: action.container
            };
        case containerVanConstants.SEARCH_CONTAINER_VAN:
            return {
                ...state,
                searchVan: action.searchVan
            };
        case containerVanConstants.CONTAINER_VAN_CLEAR:
            return {
                ...state,
                searchVan: [],
                container: null,
                containers: null,
            };
        case containerVanConstants.ALL_BOOKING_CONTAINER:
            return {
                ...state,
                bookingContainer: action.bookingContainer
            };
        default:
            return state;
    }
}